



















import {Component, Prop, Vue} from "vue-property-decorator";
import {PickingListType} from "@/enums/type/pickinglisttype";

@Component({
    name: "PLPrintFooter"
})
export default class extends Vue {
    @Prop({ type: String, required: true }) readonly postOffice!: string;
    @Prop({ type: String, required: true }) readonly createdBy!: string;
    @Prop({ type: String, required: true }) readonly employee!: string;
}
